<div class="public-chat-box">
  <form
    class="public-chat-box__form"
    [formGroup]="publicChatForm"
    (submit)="submitContactForm()">
    <!-- name input -->
    <pwj-input
      icon="user-1"
      iconPosition="left"
      placeholder="global.enter_your_full_Name"
      label="global.full_Name"
      formControlName="fullname"
      [messages]="{ required: 'requires.fullName' }"></pwj-input>

    <!-- email input -->
    <pwj-input
      icon="mail"
      iconPosition="left"
      type="email"
      placeholder="global.enter_your_email"
      label="global.email"
      formControlName="email"
      [messages]="{
        required: 'requires.emailAddress',
        email: 'requires.invalidEmail',
      }"></pwj-input>

    <!-- submit btn -->
    <div class="form-btn-container">
      <pwj-button
        variant="primary"
        size="medium"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        type="submit"
        [disabled]="isChatLoading"
        >{{ 'global.startChat' | translate }}</pwj-button
      >
    </div>
  </form>

  @if (isChatLoading) {
    <div class="public-chat-box__loading-page">
      <img
        ngSrc="assets/icons/messenger-loading-icon.svg"
        alt="loading"
        width="40"
        height="40" />
    </div>
  }
</div>
